<template>
  <div class="map-chart" :style="{height: `${height}px`}">
    <div v-if="mapLoading || loading" class="spin-loading"><a-spin tip="地图绘制中..." /></div>
    <v-chart
      v-if="!mapLoading && !loading"
      :force-fit="true" :height="height" :data="mapDatas" :animate="false"
      :scale="[...geoScale, ...geoScaleConfig]" :padding="padding"
      :onDblClick="handlerMapDblclick"
    >
      <v-legend position="right-center" :offsetX="30"/>
      <v-tooltip :showTitle="false"/>
      <!-- :label="geoLabel" -->
      <v-polygon
        position="longitude*latitude" :tooltip="tooltipConfig || 'district*value'"
        :vStyle="geoStyle" :color="geoColors"
      />
    </v-chart>
  </div>
</template>

<script>

const DataSet = require('@antv/data-set')

export default {
  name: 'MapChart',
  props: {
    height: { type: Number, default: 350 },
    padding: { type: Array, default: () => [10, 10, 10, 10] },
    mapCode: { type: Number, default: 100000 },
    datas: { type: Array, default: () => [] },
    tooltipConfig: { type: [Array, String], default: '' },
    geoScaleConfig: { type: Array, default: () => [] },
    geoColorsStr: { type: String, default: '#EBEDF0-#5EBCFF-#4CB1FF-#3BA6FF-#299AFF-#1890FF-#1387F2-#0E7DE6-#0974D9-#046BCC' },
    loading: { type: Boolean, default: false }
  },
  components: {},
  data () {
    return {
      mapLoading: true,
      geoScale: [
        { dataKey: 'value', alias: '数量' },
        { dataKey: 'district', alias: '地区名称' },
        { dataKey: 'latitude', sync: true, nice: false },
        { dataKey: 'longitude', sync: true, nice: false }
      ],
      geoStyle: {
        stroke: '#b1b1b1',
        lineWidth: 0.5
      },
      geoLabel: ['district*value', this.geoLabelFun],
      geoColors: ['value', this.geoColorsStr],

      mapLevel: 'province', // 地图展示等级
      mapDatas: null

    }
  },
  computed: {},
  watch: {
    datas: function(datas) {
      if (datas.length) this.$nextTick(this.createMapDatas)
    }
  },
  created() {
    this.createMapDatas()
  },
  methods: {
    // async createMapDatas() {
    //   try {
    //     // 获取目标地图数据
    //     let geoData = await this.getGeoJSON()
    //     // 构造地图展示数据
    //     const mapDatas = []
    //     geoData && geoData.transform({
    //       type: 'map',
    //       callback: row => {
    //         const { name, longitude, latitude, centroidX, centroidY, properties } = row
    //         const target = this.datas.find(
    //           item => item.district === properties.fullname || item.district === name
    //         )
    //         const value = target ? target.value : 0
    //
    //         mapDatas.push({
    //           // name: properties.fullname,
    //           district: properties.fullname,
    //           longitude, latitude, centroidX, centroidY,
    //           value, properties
    //         })
    //         return row
    //       }
    //     })
    //     geoData = null
    //     // 赋值绘制地图数据
    //     this.mapDatas = mapDatas
    //   } catch (error) {}
    //
    //   this.mapLoading = false
    // },
    // // 获取地图 GeoJSON 数据
    // async getGeoJSON() {
    //   let geoData = null
    //   try {
    //     const res = await GetGeoJSON(this.mapCode)
    //     // const res = await require(`@/assets/maps/${this.mapCode}.json`)
    //     geoData = new DataSet.View().source(res, { type: 'GeoJSON' })
    //   } catch (error) {}
    //
    //   return geoData
    // },
    //
    // handlerMapDblclick(e, chart) {
    //   try {
    //     let { shape: { name: shapName }, data } = e
    //     let mapName, mapCode
    //     if (!shapName) {
    //       mapName = ''
    //       mapCode = 100000
    //
    //       // 地图等级为 city 时点击地图空白处，则返回上一级地图（即中国地图）
    //       // if (this.mapLevel === 'city') {
    //       //   this.mapLevel = 'province'
    //       //   mapName = ''
    //       //   mapCode = 100000
    //       // }
    //     } else {
    //       if (shapName === 'polygon') data = data._origin
    //       const { value } = data
    //       const { fullname, level, code } = data.properties
    //       // 点击地区等级为 province 且统计值大于 0，则下钻到该省
    //       if (level === 'province' && value > 0) {
    //         // this.mapLevel = 'city'
    //         mapName = fullname
    //         mapCode = code
    //       }
    //     }
    //
    //     if (mapCode && mapCode !== this.mapCode) {
    //       this.mapLoading = true
    //       this.$nextTick(() => {
    //         this.$emit('dblclick', { mapName, mapCode })
    //       })
    //     }
    //   } catch (error) {}
    //
    // },
    //
    // geoLabelFun(name, value) {
    //   const defaultStyle = {
    //     offset: 0,
    //     textStyle: {
    //       fill: '#fff',
    //       fontSize: 12,
    //       shadowBlur: 2,
    //       shadowColor: 'rgba(0, 0, 0, .45)'
    //     }
    //   }
    //   // 调整 label 位置
    //   switch (name) {
    //     case '澳门':
    //       defaultStyle.offset = -10
    //       break
    //     case '内蒙古': case '河北':
    //       defaultStyle.offset = -20
    //       break
    //     default:
    //       break
    //   }
    //   // return { value: name, ...defaultStyle }
    //
    //   // 值大于 1000，则显示地理名称
    //   // if (value > 1000) return { value: name, ...defaultStyle }
    // }
  }
}
</script>

<style lang="less" scoped>
.spin-loading{
  background: rgba(255, 255, 255, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
